import request from '@utils/request'
import store from '@/store'
// 首页
export const wechatHome = (param)=>request('wechat',{
    ...param,
    openid:store.state.openid
})
//提交
export const apiCheck = (param)=>request('wechat/order/check',{
    ...param,
})
//刷新验证码
export const apiVerify_code = (param)=>request('wechat/verify_code',{
    ...param,
})
//详情接口
export const apiDetail = (param)=>request('wechat/product/detail',{
    ...param,
})
//
export const apiCreate = (param)=>request('wechat/order/create',{
    ...param,
})

//请求微信接口
export const apiOpenid = (param)=>request('wechat/member/oauth',param,)
//个人中心
export const apiInfo = (param)=>request('wechat/member/info',{
    ...param,
})
//我的订单
export const orderList = (param)=>request('wechat/member/order_list',{
    ...param,
})
//多卡公众号二维码
export const qrcodeDuoKa = (param)=>request('wechat/order/qrcode',{
    ...param,
})
//订单详情
export const orderDetail = (param)=>request('wechat/member/order_detail',{
    ...param,
},"get")
